import {
  Stack,
  Typography,
} from '@mui/material';
import { CheckIcon, TruckIcon } from 'lucide-react';
import { FC, memo } from 'react';
import { LaneSummary } from 'src/entities/ShipmentOrderLane';

type Props = {
  summary: LaneSummary | undefined;
  isLoading: boolean;
};

/**
 * レーンサマリーカードコンポーネント
 * 一覧画面上部に表示するサマリー情報
 */
const LaneSummaryCard: FC<Props> = memo(({ summary, isLoading }) => {
  const inHouseTruckRate = summary && summary.laneCount > 0
    ? (summary.inHouseTruckCount / summary.laneCount) * 100
    : 0;
  const partnerTruckRate = summary && summary.laneCount > 0
    ? (summary.partnerTruckCount / summary.laneCount) * 100
    : 0;

  if (isLoading) return null;

  return (
    <Stack direction="row" spacing={4} justifyContent="space-around" alignItems="center" sx={{ height: '100%', pr: 1 }}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <TruckIcon className="flex items-center gap-2" />
        <Typography>総数:</Typography>
        <Typography sx={{ fontWeight: 'bold' }}>{summary?.laneCount ?? 0}</Typography>
        <Typography>
          (自社: {summary?.inHouseTruckCount ?? 0}台/{inHouseTruckRate}% ,協力: {summary?.partnerTruckCount ?? 0}台/{partnerTruckRate}%)
        </Typography>
      </Stack>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
        <div className="w-2 h-2 rounded-full bg-red-500"></div>
        <span className="text-gray-600">未配車:</span>
        <span className="font-semibold text-red-600">{summary?.unassignedLaneCount ?? 0}</span>
      </Stack>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
        <div className="w-2 h-2 rounded-full bg-blue-500"></div>
        <span className="text-gray-600">配車済:</span>
        <span className="font-semibold text-blue-600">{summary?.assignedLaneCount ?? 0}</span>
      </Stack>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
        <CheckIcon className="h-4 w-4 text-green-500" />
        <span className="text-gray-600">配車完了率:</span>
        <span className="font-semibold text-green-600">{summary?.assignmentRate?.toFixed(0) ?? '0'}%</span>
      </Stack>
    </Stack>
  );
});

export default LaneSummaryCard;
